import { axios } from '../utils'
import { CoordiProductParam } from 'common/types/params'
import { CoordiProductList } from 'common/types/entities/list'
import { ExtendedCoordiProduct } from 'common/types/entities/mongo/coordiProduct'

export const fetchCoordiProductList = async (params: CoordiProductParam): Promise<CoordiProductList> => {
  const response = await axios.get<CoordiProductList>(`/v1/coordi-products`, { params })
  return response && response.data
}

export const fetchCoordiProductForList = async (
  id: string,
  params: CoordiProductParam,
): Promise<ExtendedCoordiProduct> => {
  const response = await axios.get<ExtendedCoordiProduct>(`/v1/coordi-products/${id}/list-type`, { params })
  return response && response.data
}
